import { render } from "./NewRequestView.vue?vue&type=template&id=6d5ca60a&scoped=true"
import script from "./NewRequestView.vue?vue&type=script&lang=js"
export * from "./NewRequestView.vue?vue&type=script&lang=js"

import "./NewRequestView.vue?vue&type=style&index=0&id=6d5ca60a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d5ca60a"]])

export default __exports__